<template>
    <div class="pre-validate-icons-wrapper">
        <Transition name="validate-icon">
            <div
                v-if="valid === false"
                class="pre-validate-icon--invalid"
                @click="showPopup"
            ></div>
            <div
                v-else-if="valid === true"
                class="pre-validate-icon--valid"
            ></div>
        </Transition>
    </div>
</template>

<script>
import LanguageFile from '../../../../../js/vue-flows/translations/LanguageFile.vue';
import { sbPopup } from '../../../../../js/vue-flows/default-components/sb-popup/v1/sb-popup-1.1.0.js';

export default {
    mixins: [LanguageFile],

    props: {
        name: {
            type: String,
            required: true,
        },

        valid: {
            type: Boolean,
            required: false,
            default: null,
        },
    },

    computed: {
        getTitle() {
            return this.getTranslation(this.name);
        },
    },

    methods: {
        showPopup() {
            sbPopup(this.getTitle, 'error');
        },
    },
};
</script>

<style lang="scss">
.validate-icon-leave-active {
    transition: all .3s ease;
}
.validate-icon-enter-active {
    transition: all .3s ease .3s;
}

.validate-icon-leave-to,
.validate-icon-enter-from {
    opacity: 0;
}
</style>
